/**
 * CustomerOrgsRpcClient — AtomRpc integration for the customer-facing,
 * authenticated org-membership endpoint (`customers.listForActor`, CLA-705).
 *
 * Backs the dashboard multi-org picker: it returns every customer (org) the
 * authenticated caller is a member of (the backend resolves the caller from
 * `CurrentActor`, never client input). Clerk-authed, same protocol/token
 * plumbing as the other authenticated clients.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { CustomerOrgsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class CustomerOrgsRpcClient extends AtomRpc.Tag<CustomerOrgsRpcClient>()(
  "CustomerOrgsRpcClient",
  {
    group: CustomerOrgsRpcs,
    protocol: makeRpcClientLayer(CustomerOrgsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
